function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons-weight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M12,3C13.657,3 15,4.343 15,6C15,6.351 14.94,6.688 14.829,7.001L18,7L22,21L2,21L6,7L9.171,7.001C9.06,6.688 9,6.351 9,6C9,4.343 10.343,3 12,3ZM16.473,9L7.442,9L4.648,19L19.422,19L16.473,9ZM12,5C11.448,5 11,5.448 11,6C11,6.552 11.448,7 12,7C12.552,7 13,6.552 13,6C13,5.448 12.552,5 12,5Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/Weight.c6aa95b6a1c4335221473bb3f34f42ec.svg";
export { ForwardRef as ReactComponent };